import { AddFailureAction, AddRequestAction, AddSuccessAction, DeleteFailureAction, DeleteRequestAction, DeleteSuccessAction, SetLastAddedIdAction, SetLastUpdatedIdAction, SetLastDocIdAction, StrapiActionTypes, StrapiItem, UpdateFailureAction, UpdateRequestAction, UpdateSuccessAction } from "../../types/strapiGOS";

export const addDataGOS = (modelName: string, data: any, creatorId?: string): AddRequestAction => ({
  type: StrapiActionTypes.ADD_REQUEST_GOS,
  payload: {
    modelName,
    data,
    creatorId,
  },
});

export const addDataGOSSuccess = (modelName: string, data: StrapiItem, creatorId?: string): AddSuccessAction => ({
  type: StrapiActionTypes.ADD_SUCCESS_GOS,
  payload: {
    modelName,
    data,
    creatorId,
  },
});

export const addDataGOSFailure = (modelName: string, error: string): AddFailureAction => ({
  type: StrapiActionTypes.ADD_FAILURE_GOS,
  payload: {
    modelName,
    error,
  },
});

export const updateDataGOS = (modelName: string, documentId: string, data: any): UpdateRequestAction => ({
  type: StrapiActionTypes.UPDATE_REQUEST_GOS,
  payload: {
    modelName,
    documentId,
    data,
  },
});

export const updateDataGOSSuccess = (modelName: string, data: StrapiItem): UpdateSuccessAction => ({
  type: StrapiActionTypes.UPDATE_SUCCESS_GOS,
  payload: {
    modelName,
    data,
  },
});

export const updateDataGOSFailure = (modelName: string, error: string): UpdateFailureAction => ({
  type: StrapiActionTypes.UPDATE_FAILURE_GOS,
  payload: {
    modelName,
    error,
  },
});

export const setLastDocId = (modelName: string, documentId: string | null): SetLastDocIdAction => ({
  type: StrapiActionTypes.SET_LAST_DOC_ID_GOS,
  payload: {
    modelName,
    documentId,
  },
});

export const setLastAddedId = (modelName: string, id: number | null): SetLastAddedIdAction => ({
  type: StrapiActionTypes.SET_LAST_ADDED_ID_GOS,
  payload: {
    modelName,
    id,
  },
});

export const setLastUpdatedId = (modelName: string, id: number | null): SetLastUpdatedIdAction => ({
  type: StrapiActionTypes.SET_LAST_UPDATED_ID_GOS,
  payload: {
    modelName,
    id,
  },
});

export const deleteDataGOS = (modelName: string, documentId: string): DeleteRequestAction => ({
  type: StrapiActionTypes.DELETE_REQUEST_GOS,
  payload: {
    modelName,
    documentId,
  },
});

export const deleteDataGOSSuccess = (modelName: string, documentId: string): DeleteSuccessAction => ({
  type: StrapiActionTypes.DELETE_SUCCESS_GOS,
  payload: {
    modelName,
    documentId,
  },
});

export const deleteDataGOSFailure = (modelName: string, error: string): DeleteFailureAction => ({
  type: StrapiActionTypes.DELETE_FAILURE_GOS,
  payload: {
    modelName,
    error,
  },
});